<template>
  <div class="page-content">
    <div class="settings-grid">
      <div class="settings-card">
        <div class="card-header">
          <h3>注册设置</h3>
        </div>
        <div class="card-body">
          <div class="setting-item">
            <div class="setting-info">
              <span class="setting-label">开放注册</span>
              <span class="setting-desc">允许新用户自主注册账号</span>
            </div>
            <button
              class="toggle-btn"
              :class="{ active: settings.register_enabled }"
              @click="toggleSetting('register_enabled')"
            >
              <span class="toggle-slider"></span>
            </button>
          </div>
          <div class="setting-item">
            <div class="setting-info">
              <span class="setting-label">启用邀请码</span>
              <span class="setting-desc">注册时需要输入有效的邀请码</span>
            </div>
            <button
              class="toggle-btn"
              :class="{ active: settings.invitation_required }"
              @click="toggleSetting('invitation_required')"
            >
              <span class="toggle-slider"></span>
            </button>
          </div>
        </div>
      </div>

      <div class="settings-card">
        <div class="card-header">
          <h3>聊天设置</h3>
        </div>
        <div class="card-body">
          <div class="setting-item">
            <div class="setting-info">
              <span class="setting-label">允许私聊</span>
              <span class="setting-desc">允许用户之间发起私聊</span>
            </div>
            <button
              class="toggle-btn"
              :class="{ active: settings.allowPrivateChat }"
              @click="toggleSetting('allowPrivateChat')"
            >
              <span class="toggle-slider"></span>
            </button>
          </div>
          <div class="setting-item">
            <div class="setting-info">
              <span class="setting-label">允许创建群聊</span>
              <span class="setting-desc">允许普通用户创建群聊</span>
            </div>
            <button
              class="toggle-btn"
              :class="{ active: settings.allowCreateGroup }"
              @click="toggleSetting('allowCreateGroup')"
            >
              <span class="toggle-slider"></span>
            </button>
          </div>
        </div>
      </div>

      <div class="settings-card">
        <div class="card-header">
          <h3>安全设置</h3>
        </div>
        <div class="card-body">
          <div class="setting-item">
            <div class="setting-info">
              <span class="setting-label">登录验证码</span>
              <span class="setting-desc">登录时需要输入图形验证码</span>
            </div>
            <button
              class="toggle-btn"
              :class="{ active: settings.requireCaptcha }"
              @click="toggleSetting('requireCaptcha')"
            >
              <span class="toggle-slider"></span>
            </button>
          </div>
          <div class="setting-item">
            <div class="setting-info">
              <span class="setting-label">强制修改密码</span>
              <span class="setting-desc">首次登录强制修改默认密码</span>
            </div>
            <button
              class="toggle-btn"
              :class="{ active: settings.forcePasswordChange }"
              @click="toggleSetting('forcePasswordChange')"
            >
              <span class="toggle-slider"></span>
            </button>
          </div>
        </div>
      </div>

      <div class="settings-card">
        <div class="card-header">
          <h3>版权设置</h3>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label>版权信息</label>
            <input
              v-model="settings.copyright"
              type="text"
              class="form-input"
              placeholder="© 2026 叨叨"
              @blur="saveSetting('copyright')"
            />
          </div>
        </div>
      </div>
    </div>

    </div>
</template>

<script>
export default {
  name: 'SystemManagement',
  data() {
    return {
      settings: {
        register_enabled: false,
        invitation_required: false,
        allowPrivateChat: true,
        allowCreateGroup: true,
        requireCaptcha: false,
        forcePasswordChange: true,
        copyright: '© 2026 叨叨'
      }
    }
  },
  mounted() {
    this.loadSettings()
  },
  methods: {
    async loadSettings() {
      try {
        const response = await this.$http({
          url: '/admin/system/config/list',
          method: 'get'
        })
        if (response) {
          const configMap = {}
          response.forEach(item => {
            const key = item.configKey || item.key
            const value = item.configValue || item.value
            const parsedValue = value === 'true' ? true : (value === 'false' ? false : value)
            configMap[key] = parsedValue
          })
          this.settings = { ...this.settings, ...configMap }
        }
      } catch (error) {
        this.$message.error('加载系统配置失败')
      }
    },
    toggleSetting(key) {
      this.settings[key] = !this.settings[key]
      this.saveSetting(key)
    },
    async saveSetting(key) {
      try {
        const value = typeof this.settings[key] === 'boolean' ? String(this.settings[key]) : this.settings[key]
        await this.$http({
          url: '/admin/system/config/update',
          method: 'post',
          data: {
            key: key,
            value: value
          }
        })
        this.$message.success('设置已保存')
      } catch (error) {
        this.$message.error('保存失败')
      }
    }
  }
}
</script>

<style scoped>
.page-content {
  max-width: 100%;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
}

.settings-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.card-header {
  padding: 16px 24px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.card-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.card-body {
  padding: 16px 24px;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}

.setting-item:last-child {
  border-bottom: none;
}

.setting-info {
  display: flex;
  flex-direction: column;
}

.setting-label {
  font-size: 14px;
  font-weight: 500;
  color: #334155;
}

.setting-desc {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 4px;
}

.toggle-btn {
  width: 44px;
  height: 24px;
  border-radius: 12px;
  background: #e2e8f0;
  border: none;
  cursor: pointer;
  position: relative;
  transition: background 0.2s;
}

.toggle-btn.active {
  background: #07c160;
}

.toggle-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}

.toggle-btn.active .toggle-slider {
  transform: translateX(20px);
}

.form-group {
  margin-bottom: 16px;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
}

.form-input:focus {
  border-color: #07c160;
  box-shadow: 0 0 0 3px rgba(7, 193, 96, 0.1);
}

.action-bar {
  display: flex;
  justify-content: flex-end;
}

.btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn i {
  font-size: 16px;
}

.btn-primary {
  background: #07c160;
  color: #fff;
  box-shadow: 0 2px 8px rgba(7, 193, 96, 0.25);
}

.btn-primary:hover {
  background: #06ae56;
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.35);
}
</style>